import React, {Fragment, useState} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import VoucherForm from './forms/VoucherForm';
import VoucherList from './lists/VoucherList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {paramsSerializer, postData, UrlGenerator} from "../../utils/request";
import Modal from "../layout/Modal";
import TextInput from "../form/TextInput";
import { saveAs } from 'file-saver';
import DateTimeInput from "../form/DateTimeInput";
import RadioGroup from "../form/RadioGroup";
import Confirm from "../form/Confirm";
import Select from "../form/Select";
import {CurrencyFormatter, UnitFormatter} from "../../utils/formatters";
import Portal from "src/components/layout/Portal";
import parse_str from "locutus/php/strings/parse_str";

const YearExport = (props) => {
    const [year, setYear] = useState((new Date()).getFullYear());
    const [state, setState] = useState(false);
    return <Fragment>
        <Portal>
            <Modal
                state={state}
                header="Éves export"
                buttons={[
                    {
                        text: "Mégse",
                        onClose: true,
                        onClick: () => {
                            setState(!state);
                        }
                    },
                    {
                        icon: {lib: "far", name: "file-excel"},
                        text: "Export",
                        props: {color: "primary", disabled: props.disabled || props.isLoading},
                        onClick: () => {
                            let params = {};
                            parse_str("component=Voucher&option=componentlist&view%5Bid%5D=&view%5Bbarcode%5D=&view%5Bserial_number%5D=&view%5Bamount%5D=&view%5Bsold%5D=&view%5Bused%5D=&resptype=excel&getcolumns=1&page=1&itemsperpage=0&filter=%5B%7B%22field%22%3A%22sold%22%2C%22value%22%3A%5B%22" + year + "-01-01%2000%3A00%3A00%22%2C%22" + year + "-12-31%2023%3A59%3A59%22%5D%2C%22operator%22%3A%22between%22%7D%5D&order=%5B%7B%22field%22%3A%22id%22%2C%22direction%22%3A%22DESC%22%7D%5D&group=%5B%5D&view%5Bvalid_until%5D=&view%5Bexpired%5D=", params);
                            params.name = "Utalvány " + year;
                            let url = UrlGenerator();
                            delete url.fragment;
                            url.query = params;
                            window.open(url.toString(), "_blank");
                        }
                    }
                ]}
            >
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <TextInput
                                type="number"
                                label={false}
                                placeholder="Év"
                                max={(new Date()).getFullYear()}
                                value={year}
                                saveChanges={(field, value) => {
                                    setYear(value);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
        </Portal>
        <Button
            disabled={props.isLoading}
            color="default"
            onClick={() => setState(true)}
            icon={{lib: "far", name: "file-excel"}}
        >
            Éves export
        </Button>
    </Fragment>
}

// https://www.pagony.hu/index.php?component=Voucher&option=componentlist&view%5Bid%5D=&view%5Bbarcode%5D=&view%5Bserial_number%5D=&view%5Bamount%5D=&view%5Bsold%5D=&view%5Bused%5D=&resptype=json&getcolumns=1&page=1&itemsperpage=0&filter=%5B%7B%22field%22%3A%22sold%22%2C%22value%22%3A%5B%222021-01-01%2000%3A00%3A00%22%2C%222021-12-31%2023%3A59%3A59%22%5D%2C%22operator%22%3A%22between%22%7D%5D&order=%5B%7B%22field%22%3A%22id%22%2C%22direction%22%3A%22DESC%22%7D%5D&group=%5B%5D&_=1647876430466&view%5Bvalid_until%5D=&view%5Bexpired%5D=
class Export extends React.Component {

    state = {
        opened: false,
        generate: {
            'export': 'sold'
        }
    };

    export = () => {
        const params = {...this.state.generate};
        params.resptype = "excel";
        params.option = this.props.componentConfig.componentname;
        let url = UrlGenerator();
        delete url.fragment;
        url.query = params;
        window.open(url.toString(), "_blank");
    }

    render() {
        return (
            <Fragment>
                <Portal>
                    <Modal
                        state={this.state.opened}
                        header="Export"
                        buttons={[
                            {
                                text: "Mégse",
                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                onClose: true,
                                onClick: () => {
                                    this.setState({opened: false});
                                }
                            },
                            {
                                icon: {lib: "far", name: "file-excel"},
                                text: "Export",
                                props: {color: "primary", disabled: this.props.disabled || this.props.isLoading},
                                onClick: this.export
                            }
                        ]}
                    >

                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <RadioGroup
                                        name="export"
                                        labelKey="label"
                                        valueKey="value"
                                        objectValue={false}
                                        options={[{value: "sold", label: "Eladott utalványok"},{value: "redeemed", label: "Beváltott utalványok"}]}
                                        value={this.state.generate.export}
                                        label={false}
                                        saveChanges={(field, type) => {
                                            this.setState({generate: {...this.state.generate, 'export': type}});
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <DateTimeInput
                                        label={false}
                                        isClearable={true}
                                        placeholder="Dátumtól"
                                        maxDate={this.state.generate.to}
                                        value={this.state.generate.from}
                                        saveChanges={(field, from) => {
                                            this.setState({generate: {...this.state.generate, from}});
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <DateTimeInput
                                        label={false}
                                        isClearable={true}
                                        placeholder="Dátumig, alapértelmezett: mai napig"
                                        minDate={this.state.generate.from}
                                        value={this.state.generate.to}
                                        saveChanges={(field, to) => {
                                            this.setState({generate: {...this.state.generate, to}});
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </Modal>
                </Portal>
                <Button
                    key="0"
                    disabled={this.props.isLoading}
                    color="default"
                    onClick={() => this.setState({opened: true})}
                    icon={{lib: "far", name: "file-excel"}}
                >
                    Export
                </Button>
            </Fragment>
        );
    }
}

class VoucherEditor extends React.Component {

    state = {
        generate: {},
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    generateVouchers = async () => {
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.generateVouchers',
                ...this.state.generate
            });
            if (response instanceof Blob) {
                saveAs(response, response.filename);
            }
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            this.setState({generate: {}});
            return response;
        });
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Utalványok"
                    footer={[
                        /*<Button
                            key="0"
                            disabled={this.props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>,*/
                        <Export key="9" {...this.props}/>,
                        <YearExport key="10" {...this.props}/>,
                        <Confirm
                            key="20"
                            disabled={this.props.isLoading}
                            color="primary"
                            onAccept={this.generateVouchers}
                            header="Generálás"
                            acceptButton="Generálás"
                            body={
                                <Fragment>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group unit">
                                                <TextInput
                                                    label="Darab"
                                                    type="number"
                                                    formatter={UnitFormatter}
                                                    value={this.state.generate.qty}
                                                    saveChanges={(field, qty) => {
                                                        this.setState({generate: {...this.state.generate, qty}});
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group currency">
                                                <TextInput
                                                    label="Érték"
                                                    type="number"
                                                    formatter={CurrencyFormatter}
                                                    value={this.state.generate.voucher_value}
                                                    saveChanges={(field, voucher_value) => {
                                                        this.setState({generate: {...this.state.generate, voucher_value}});
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {this.props.componentConfig?.fielddefs?.pos && <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <Select
                                                    label="Eladási hely"
                                                    component="PointOfSale"
                                                    storeType="local"
                                                    name="pos"
                                                    objectValue={false}
                                                    labelKey="name"
                                                    value={this.state.generate.pos}
                                                    saveChanges={(field, pos) => {
                                                        this.setState({generate: {...this.state.generate, pos}});
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>}
                                </Fragment>
                            }
                        >
                            Generálás
                        </Confirm>
                    ]}
                >
                    <VoucherList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
            {this.props.values[this.props.componentConfig.idfield] && <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Utalvány"
                    footer={[
                        <Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>
                    ]}
                >
                    <VoucherForm {...this.props} />
                </Editor>}
        </Fragment>;
    }
}

export default createEditor({
    componentName: "Voucher",
    WrappedComponent: VoucherEditor
});
